import { useEffect, useState } from 'react';
import { listarPendenciasReinf, listarTxSemLcto, descartarPendencia } from '../api';
import { PageHeader, Loading, Empty, Alert, KPI } from '../components/common';
import { fmtMoeda, fmtData, fmtCnpj } from '../lib/format';

export default function Pendencias({ clienteId }) {
  const [aba, setAba] = useState('reinf');
  const [pendReinf, setPendReinf] = useState([]);
  const [pendFin, setPendFin] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState(null);

  const carregar = () => {
    if (!clienteId) return;
    setLoading(true);
    Promise.allSettled([
      listarPendenciasReinf(clienteId),
      listarTxSemLcto(clienteId, false),
    ]).then(([r1, r2]) => {
      if (r1.status === 'fulfilled') setPendReinf(r1.value.items || []);
      if (r2.status === 'fulfilled') setPendFin(r2.value.items || []);
      setLoading(false);
    });
  };
  useEffect(carregar, [clienteId]);

  const descartar = async (id) => {
    const motivo = prompt('Motivo do descarte:');
    if (!motivo || motivo.length < 5) return;
    try {
      await descartarPendencia(id, motivo);
      setMsg({ tipo: 'success', txt: `Pendência #${id} descartada` });
      carregar();
    } catch (err) {
      setMsg({ tipo: 'danger', txt: err.message });
    }
  };

  if (!clienteId) return <Empty title="Selecione um cliente" />;

  return (
    <>
      <PageHeader
        title="Pendências"
        sub="Itens detectados pelos workers que precisam de revisão humana"
      />

      {msg && <Alert tipo={msg.tipo}>{msg.txt}</Alert>}

      <div className="kpi-grid">
        <KPI label="Notas Sieg sem match" value={pendReinf.length} variant={pendReinf.length > 0 ? 'warning' : ''} sub="aguardando casamento com tx Finance" />
        <KPI label="Tx Finance sem mapa"  value={pendFin.length}   variant={pendFin.length > 0 ? 'warning' : ''}   sub="categoria sem conta contábil cadastrada" />
      </div>

      <div className="toolbar">
        <button className={aba === 'reinf' ? 'primary' : ''} onClick={() => setAba('reinf')}>
          Notas Sieg sem match ({pendReinf.length})
        </button>
        <button className={aba === 'fin' ? 'primary' : ''} onClick={() => setAba('fin')}>
          Tx Finance sem lançamento ({pendFin.length})
        </button>
      </div>

      <div className="card">
        {loading ? <Loading /> : (
          aba === 'reinf' ? (
            pendReinf.length === 0 ? (
              <Empty title="✓ Todas notas conciliadas" sub="Nenhuma nota Sieg sem transação correspondente." />
            ) : (
              <table className="data">
                <thead>
                  <tr>
                    <th>Período</th>
                    <th>Emitente</th>
                    <th>Data emissão</th>
                    <th className="num">Valor</th>
                    <th>Descrição</th>
                    <th>Motivo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pendReinf.map(p => (
                    <tr key={p.id}>
                      <td>{p.per_apur}</td>
                      <td>
                        <div>{p.nome_emitente || '—'}</div>
                        <div className="small muted">{fmtCnpj(p.cnpj_emitente)}</div>
                      </td>
                      <td>{fmtData(p.data_emissao)}</td>
                      <td className="num bold">{fmtMoeda(p.valor_total)}</td>
                      <td className="small">{p.discriminacao?.slice(0, 80) || '—'}</td>
                      <td className="small muted">{p.motivo}</td>
                      <td>
                        <button className="ghost danger" onClick={() => descartar(p.id)}>Descartar</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : (
            pendFin.length === 0 ? (
              <Empty title="✓ Todas tx contabilizadas" sub="Todas as transações do Finance têm lançamento contábil." />
            ) : (
              <table className="data">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Histórico</th>
                    <th>Categoria</th>
                    <th className="num">Valor</th>
                    <th>Motivo</th>
                  </tr>
                </thead>
                <tbody>
                  {pendFin.map(p => (
                    <tr key={p.id}>
                      <td>{fmtData(p.data_tx)}</td>
                      <td>{p.historico}</td>
                      <td><span className="badge badge--neutral">{p.categoria}</span></td>
                      <td className="num bold">{fmtMoeda(p.valor)}</td>
                      <td className="small muted">{p.motivo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          )
        )}
      </div>
    </>
  );
}
